import React, { useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import { ROLES } from "../../../constants/UserRoles";
import ViewGuideMain from "../../../components/b2bCandidate/preparation/ViewGuideMain";

function B2BCandViewGuide() {
  const [guideDetails, setGuideDetails] = useState();
  const guideData = (value) => {
    setGuideDetails(value);
  };
  return (
    <div className="hirePlusPlusPageContent ">
      <Sidebar
        activePage="viewGuide"
        collapseSidbar="left"
        userRole={ROLES.b2b_candidate}
      />
      <div className="w-full hireplusplusRightContent">
        <Topbar
          activePage="viewGuide"
          userRole={ROLES.b2b_candidate}
          newTitle={guideDetails?.jobTitle}
          // driverFlag="viewSingleGuide"
        />
        <ViewGuideMain guideData={guideData} />
      </div>
    </div>
  );
}

export default B2BCandViewGuide;
